/**
 * useSyncStatus — reactive view of the offline outbox: how many ops are queued
 * and whether a sync is in progress.
 */
import { useState, useEffect } from 'react';
import { subscribeSync } from '@/lib/syncEngine';

export function useSyncStatus() {
  const [state, setState] = useState({ pending: 0, syncing: false });
  useEffect(() => subscribeSync(setState), []);
  return state;
}
